// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3qRUn","subheader":"ReorderModal_subheader__3CeLq","listWrap":"ReorderModal_listWrap__OeioQ"};